module.exports = __webpack_public_path__ + "static/2-2410e0a04d6006b5399197d22c79ccec.png";